module.exports = __webpack_public_path__ + "img/search.a3faf707.svg";